/**
 * Web 端产品 id（pid）
 * 不区分 M/A、不区分端类型，统一用 *-M-Web
 * Spyx-M-Web=10005 / Msafely-M-Web=10011 / SpyPhone-M-Web=10017
 */
const WEB_PID_MAP = {
  Spyx: 10005,
  Msafely: 10011,
  Spyphone: 10017,
  SpyPhone: 10017
}

export const getWebPid = () => WEB_PID_MAP[process.env.NEXT_PUBLIC_SITE_TYPE] || 10005
